import classNames from "classnames";
import BaseModal, { BaseModalProps, Variant } from "../BaseModal/index";
import styles from "./style.module.scss";
import VLButton from "../../Buttons/VLButton";

export type VLActionModalProps = BaseModalProps & {
  actionLabel?: string;
  loading?: boolean;
  direction?: "column" | "row";
  disabled?: boolean;
  showCancel?: boolean;
  cancelLabel?: string;
  cancelBtnClassName?: string;
  primaryBtnClassName?: string;
} & (
    | { htmlType: "submit"; form: string }
    | { htmlType?: undefined; onClick: () => void }
  );

const defaultActionLabels: Record<Variant, string> = {
  error: "Try Again",
  success: "Continue",
  info: "OK",
  general: "OK",
};

const VLActionModal = ({
  isOpen,
  onClose,
  variant,
  children,
  className,
  actionLabel,
  loading = false,
  direction = "column",
  headers,
  size,
  afterOpenChange,
  showCancel,
  cancelLabel = "Cancel",
  cancelBtnClassName,
  primaryBtnClassName,
  ...rest
}: VLActionModalProps) => {
  const footerClassNames = classNames(styles.footer, {
    [styles.info]: variant === "info",
    [styles.error]: variant === "error",
    [styles.success]: variant === "success",
  });

  const footer = (
    <div className={footerClassNames}>
      {showCancel && (
        <VLButton
          type="text"
          onClick={onClose}
          disabled={loading}
          size="middle"
          text={cancelLabel}
          className={cancelBtnClassName}
        />
      )}
      <VLButton
        type="primary"
        data-testid="action-button"
        disabled={loading}
        size="middle"
        loading={loading}
        text={actionLabel || (variant && defaultActionLabels[variant])}
        className={primaryBtnClassName}
        {...rest}
      ></VLButton>
    </div>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      variant={variant}
      headers={headers}
      footer={direction === "row" ? undefined : footer}
      className={className}
      size={size}
      afterOpenChange={afterOpenChange}
    >
      <div className={styles[direction]}>
        <div className={styles.content}>{children}</div>
        {direction === "row" && footer}
      </div>
    </BaseModal>
  );
};

export default VLActionModal;
